    <div [class]="callingFrom === screen.COMMUNITY_DASHBOARD ?'text-left mb-2 mb-sm-3 public-community-dashboard-card-container': 'text-left mb-2 mb-sm-3 public-community-card-container'">
        <div>
            <div class="mb-1 d-flex justify-content-between">
                <div class="mr-3">
                    <div class="heading-4">
                        {{community?.label}}
                    </div>
                    <div class="secondary-paragraph color-grey-500">
                        {{community?.sub_text}}
                    </div>
                </div>
                <button class="view-more btn-design small outline d-flex align-items-center justify-content-around"
                    (click)="viewAllHandler()"
                    [ngClass]="community?.list.length ? 'd-flex align-items-center' : 'd-none' ">
                    <span>{{translations.key2}}</span>
                    <img src="assets/themes/icons/right-arrow-head.svg"
                        alt="right nav"
                        class="nav-icon" />
                </button>
            </div>
            <ng-container *ngIf="community?.list.length > numbers.ZERO; else noPublicCommunityData">
                <ng-container *ngTemplateOutlet="publicCommunityCardItem"></ng-container>
            </ng-container>
        </div>
    </div>

    <ng-template #publicCommunityCardItem>
        <div class="carousel custom-owl-carousel">
            <owl-carousel-o [options]="customOptions">
              <ng-template carouselSlide *ngFor="let listItem of community?.list; let index = index;">
                <div class="slide-container">
                    <app-public-community-card-item
                        appear
                        [horizontal]="true"
                        [rootMargin]="fcs.margin.publicCommunityCurrentHRootMargin"
                        [appearIds]="getAppearedIds(listItem)"
                        (appearedCards)="onCardAppear($event)"
                        [viewMore]="community?.flags.view_more"
                        [offset]="pOffset"
                        [index]="index"
                        [pCommunity]="listItem"
                        (emitViewAll)="viewAllHandler()"
                        [screenFrom]= "callFrom"
                        [callFromScreen]="callFrom"
                        [totalCommunity]= "numberOfItem"
                        (emitWithdrawRequest)="withdrawConfirmation($event)"
                        (emitCommunityDetail)="navigateTocommunityDetailHandler($event, listItem)"
                        (emitReloadCommunityList)="reloadCommunityList($event)"
                        [callingFrom]="callingFrom"
                        [carouselType]="carouselType">
                    </app-public-community-card-item>
                </div>
              </ng-template>

              <ng-template carouselSlide *ngFor="let listItem of myCommunity?.list; let index = index;">
                <div class="slide-container">
                    <app-public-community-card-item
                        appear
                        [horizontal]="true"
                        [rootMargin]="fcs.margin.publicCommunityCurrentHRootMargin"
                        [appearIds]="getAppearedIds(listItem)"
                        (appearedCards)="onCardAppear($event)"
                        [viewMore]="community?.flags.view_more"
                        [offset]="pOffset"
                        [index]="index"
                        [pCommunity]="listItem"
                        [screenFrom]= "callFrom"
                        [callFromScreen]="callFrom"
                        [totalCommunity]= "numberOfItem"
                        [callingFrom]="callingFrom"
                        [carouselType]="carouselType">
                    </app-public-community-card-item>
                </div>
              </ng-template>

              <ng-template carouselSlide *ngIf="community?.list.length >= numbers.TEN">
                <div class="slide-container">
                    <app-public-community-card-item
                        [viewMore]="community?.flags.view_more"
                        [offset]="numbers.TWO"
                        [index]="numbers.TEN"
                        [callingFrom]="callingFrom"
                        [screenFrom]= "callFrom"
                        (emitViewAll)="viewAllHandler()"
                        [carouselType]="carouselType">
                    </app-public-community-card-item>
                </div>
              </ng-template>
            </owl-carousel-o>
          </div>
          <div class="slides">
          <app-dq-owl-carousel [content]="wow" [listItems]="community?.list">
          </app-dq-owl-carousel>
          <ng-template #wow let-list let-index="index">
              <div class="slide-container">
                  <app-public-community-card-item
                      [viewMore]="community?.flags.view_more"
                      [offset]="pOffset"
                      [index]="index"
                      [pCommunity]="list"
                      (emitViewAll)="viewAllHandler()"
                      (emitWithdrawRequest)="withdrawConfirmation($event)"
                      (emitCommunityDetail)="navigateTocommunityDetailHandler($event, list)"
                      (emitReloadCommunityList)="reloadCommunityList($event)"
                      [callingFrom]="callingFrom">
                  </app-public-community-card-item>
              </div>
          </ng-template>
        </div>
    </ng-template>

    <ng-template #noPublicCommunityData>
        <div class="no-public-community-data">
            <img src="assets/themes/images/community-no-data.svg" alt="no community data" width="160" height="120">
            <p class="py-4 w-75 align-center paragraph">
                {{translations.key1}}
            </p>
        </div>
    </ng-template>

    <app-confirm-modal
      [isWithdrawRequestConfirmModalShown]="confirmationModal"
      [confirmationModalContent]="confirmationText"
      [getListItem]="confirmedCommunity"
      (resetConfirmModal)="resetConfirmModal()"
      (emitAllowAction)="allowAction($event)">
    </app-confirm-modal>
